'use client';

import { Box, Button, Typography } from '@mui/material';
import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const router = useRouter();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const reload = () => router.push('/');

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <Typography variant="button">An unknown error occurred</Typography>
          <Typography variant="body2">
            Please try reloading the page or contact support if the problem
            persists.
          </Typography>
          <Button variant="contained" color="primary" onClick={reload}>
            Reload
          </Button>
        </Box>
      </body>
    </html>
  );
}
